import Text from "aldoo-ra/Text"

export default function PoweredBy() {
  return (
    <Text
      id="powered_by"
      variant="txt1_dim"
      className="text-neutral_2"
      data={{
        developer_website: (
          <span  
            className="text-neutral_1"
          >
            Aldoo
          </span>
        ),
        year: new Date().getFullYear(),
      }}
    />
  )
}
